import React from "react";
import "./Hero.css";
import hero_image from "../../assets/daipic.png";
import hero_image_back from "../../assets/hero_image_back.png";
import heart from "../../assets/heart.png";
import calories from "../../assets/calories.png";
import { motion } from "framer-motion";
import { Link } from "react-scroll";

const Hero = () => {
	const transition = { type: "spring", duration: 2.5, bounce: 0.3 };
	const mobile = window.innerWidth <= 768;

	return (
		<main className="hero" id="hero">
			<div className="blur hero-blur-1"></div>
			<div className="blur hero-blur-2"></div>
			
			<div className="hero-left">
				<motion.div 
					initial={{ opacity: 0, y: 20 }}
					animate={{ opacity: 1, y: 0 }}
					transition={{ duration: 0.8 }}
					className="hero-badge"
				>
					<motion.div
						initial={{ left: mobile ? "120px" : "180px" }}
						whileInView={{ left: "6px" }}
						transition={{ ...transition, type: "tween", duration: 1 }}
						className="badge-overlay"
					></motion.div>
					<span className="outfit">The Best Fitness Club in Bhaktapur</span>
				</motion.div>

				<div className="hero-heading">
					<motion.div
						initial={{ opacity: 0, x: -50 }}
						animate={{ opacity: 1, x: 0 }}
						transition={{ duration: 0.8, delay: 0.2 }}
					>
						<span className="stroke-text">Unleash </span>
						<span>Your</span>
					</motion.div>
					<motion.div
						initial={{ opacity: 0, x: -50 }}
						animate={{ opacity: 1, x: 0 }}
						transition={{ duration: 0.8, delay: 0.4 }}
					>
						<span className="gradient-text">Inner Beast</span>
					</motion.div>
					<motion.p 
						initial={{ opacity: 0 }}
						animate={{ opacity: 1 }}
						transition={{ duration: 1, delay: 0.6 }}
						className="hero-subtext"
					>
						Transform your physique and mindset at Grind'On. We provide the elite equipment, expert guidance, and the relentless community you need to reach your peak potential.
					</motion.p>
				</div>

				<motion.div 
					initial={{ opacity: 0, y: 20 }}
					animate={{ opacity: 1, y: 0 }}
					transition={{ duration: 0.8, delay: 0.8 }}
					className="hero-cta"
				>
					<a href="tel:+9779863032963" className="btn btn-primary">Join Now</a>
					<Link to="plans" smooth={true} duration={700} className="btn btn-outline">View Plans</Link>
				</motion.div>

				<motion.div 
					initial={{ opacity: 0 }}
					animate={{ opacity: 1 }}
					transition={{ duration: 1, delay: 1 }}
					className="hero-contact-minimal"
				>
					<p>Bhaktapur, Sallaghari | +977 9863032963</p>
				</motion.div>
			</div>

			<div className="hero-right">
				<motion.div
					initial={{ opacity: 0, x: 100 }}
					animate={{ opacity: 1, x: 0 }}
					transition={{ duration: 1 }}
					className="hero-image-container"
				>
					<img src={hero_image} alt="Elite Athlete" className="hero-main-img" />
					<motion.img
						initial={{ scale: 0.8, opacity: 0 }}
						animate={{ scale: 1, opacity: 0.5 }}
						transition={{ duration: 1.5, delay: 0.5 }}
						src={hero_image_back}
						alt="Hero Background"
						className="hero-bg-img"
					/>
				</motion.div>

				<motion.div
					initial={{ right: "-5rem", opacity: 0 }}
					whileInView={{ right: "2rem", opacity: 1 }}
					transition={transition}
					className="floating-card glass-card heart-rate-card"
				>
					<img src={heart} alt="Heart Rate" />
					<div className="card-info">
						<span className="label">Heart Rate</span>
						<span className="value">116 BPM</span>
					</div>
				</motion.div>

				<motion.div
					initial={{ left: "-5rem", opacity: 0 }}
					whileInView={{ left: "2rem", opacity: 1 }}
					transition={transition}
					className="floating-card glass-card calories-card"
				>
					<img src={calories} alt="Calories" />
					<div className="card-info">
						<span className="label">Calories Burned</span>
						<span className="value">750 kcal</span>
					</div>
				</motion.div>
			</div>
		</main>
	);
};

export default Hero;
